import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../../firebase";

const GetAllCourses = async (ClassID) => {
  try {
    const CoursesCollection = collection(db, "Courses");

    const q = query(
      CoursesCollection,
      where("ClassID", "==", ClassID),
      where("IsDeleted", "==", false)
    );
    const CoursesSnapshot = await getDocs(q);

    let CoursesData = [];

    CoursesSnapshot.forEach((doc) => {
      CoursesData.push({ ...doc.data(), id: doc.id });
    });
    return CoursesData;
  } catch (error) {
    console.log(error);
  }
};

export default GetAllCourses;
